import { DetailConfig, ServiceDetailType, ServiceType } from "./types";

export const INTERNATIONAL = "INTERNATIONAL";

export const SERVICE_TYPE_LABEL_MAP: Record<ServiceType, string> = {
  [ServiceType.Insurance]: "Insurance",
  [ServiceType.SimCard]: "Sim Card",
  [ServiceType.EssayReview]: "Essay review",
  [ServiceType.Guardianship]: "Guardianship",
  [ServiceType.Accommodation]: "Accommodation",
  [ServiceType.LawyerConsultation]: "Lawyer consultation",
  [ServiceType.VisaSupport]: "Visa support",
  [ServiceType.OnlineCourses]: "Online Courses",
  [ServiceType.Library]: "Library",
  [ServiceType.TravelAssistance]: "Travel Assistance",
  [ServiceType.Internship]: "Internship",
  [ServiceType.Volunteering]: "Volunteering",
  [ServiceType.WorkAndTravel]: "Work and Travel",
  [ServiceType.FindJob]: "Find a Job",
  [ServiceType.Ranking]: "Ranking",
  [ServiceType.StudentLoan]: "Student Loan",
  [ServiceType.MoneyTransfer]: "Money Transfer",
  [ServiceType.PickUpDropOff]: "Pick up/Drop off",
  [ServiceType.BankCard]: "Bank Card",
  [ServiceType.LanguageCourses]: "Language Courses",
  [ServiceType.ShortProfessionalCourses]: "Short Professional Courses",
  [ServiceType.SummerSchools]: "Summer Schools",
  [ServiceType.StudentToStudentCommunication]:
    "Student to Student Communication",
  [ServiceType.ImmigrationPrograms]: "Immigration programs",
  [ServiceType.SupportService]: "Support Service",
};

export const SERVICE_TYPE_NAME_MAP: Record<ServiceType | string, ServiceType | string> = {
  [ServiceType.Insurance]: "insurance",
  [ServiceType.SimCard]: "sim-card",
  [ServiceType.EssayReview]: "essay-review",
  [ServiceType.Guardianship]: "guardianship",
  [ServiceType.Accommodation]: "accommodation",
  [ServiceType.LawyerConsultation]: "lawyer-consultation",
  [ServiceType.VisaSupport]: "visa-support",
  [ServiceType.OnlineCourses]: "online-courses",
  [ServiceType.Library]: "library",
  [ServiceType.TravelAssistance]: "travel-assistance",
  [ServiceType.Internship]: "internship",
  [ServiceType.Volunteering]: "volunteering",
  [ServiceType.WorkAndTravel]: "work-and-travel",
  [ServiceType.FindJob]: "find-a-job",
  [ServiceType.Ranking]: "ranking",
  [ServiceType.StudentLoan]: "student-loan",
  [ServiceType.MoneyTransfer]: "money-transfer",
  [ServiceType.PickUpDropOff]: "pick-up-drop",
  [ServiceType.BankCard]: "bank-card",
  [ServiceType.LanguageCourses]: "language-courses",
  [ServiceType.ShortProfessionalCourses]: "short-professional-courses",
  [ServiceType.SummerSchools]: "summer-schools",
  [ServiceType.StudentToStudentCommunication]: "student-to-student-communication",
  [ServiceType.ImmigrationPrograms]: "immigration-programs",
  [ServiceType.SupportService]: "support-service",
  "insurance": ServiceType.Insurance,
  "sim-card": ServiceType.SimCard,
  "essay-review": ServiceType.EssayReview,
  "guardianship": ServiceType.Guardianship,
  "accommodation": ServiceType.Accommodation,
  "lawyer-consultation": ServiceType.LawyerConsultation,
  "visa-support": ServiceType.VisaSupport,
  "online-courses": ServiceType.OnlineCourses,
  "library": ServiceType.Library,
  "travel-assistance": ServiceType.TravelAssistance,
  "internship": ServiceType.Internship,
  "volunteering": ServiceType.Volunteering,
  "work-and-travel": ServiceType.WorkAndTravel,
  "find-a-job": ServiceType.FindJob,
  "ranking": ServiceType.Ranking,
  "student-loan": ServiceType.StudentLoan,
  "money-transfer": ServiceType.MoneyTransfer,
  "pick-up-drop": ServiceType.PickUpDropOff,
  "bank-card": ServiceType.BankCard,
  "language-courses": ServiceType.LanguageCourses,
  "short-professional-courses": ServiceType.ShortProfessionalCourses,
  "summer-schools": ServiceType.SummerSchools,
  "student-to-student-communication": ServiceType.StudentToStudentCommunication,
  "immigration-programs": ServiceType.ImmigrationPrograms,
  "support-service": ServiceType.SupportService,
};

export const SERVICE_TYPE_ICONS: Record<ServiceType, string> = {
  [ServiceType.Insurance]: "service-insurance",
  [ServiceType.SimCard]: "service-sim-card",
  [ServiceType.EssayReview]: "service-essay-review",
  [ServiceType.Guardianship]: "service-guardianship",
  [ServiceType.Accommodation]: "service-accommodation",
  [ServiceType.LawyerConsultation]: "service-lawyer-consultation",
  [ServiceType.VisaSupport]: "service-visa-support",
  [ServiceType.OnlineCourses]: "service-online-courses",
  [ServiceType.Library]: "service-library",
  [ServiceType.TravelAssistance]: "service-travel-assistance",
  [ServiceType.Internship]: "service-internship",
  [ServiceType.Volunteering]: "service-volunteering",
  [ServiceType.WorkAndTravel]: "service-work-and-travel",
  [ServiceType.FindJob]: "service-find-a-job",
  [ServiceType.Ranking]: "service-ranking",
  [ServiceType.StudentLoan]: "service-student-loan",
  [ServiceType.MoneyTransfer]: "service-money-transfer",
  [ServiceType.PickUpDropOff]: "service-pick-up-drop",
  [ServiceType.BankCard]: "service-bank-card",
  [ServiceType.LanguageCourses]: "service-language-courses",
  [ServiceType.ShortProfessionalCourses]: "service-short-courses",
  [ServiceType.SummerSchools]: "service-summer-schools",
  [ServiceType.StudentToStudentCommunication]: "service-student-communication",
  [ServiceType.ImmigrationPrograms]: "service-immigration-programs",
  [ServiceType.SupportService]: "service-support-service",
};

export const SERVICE_TYPES_OPTIONS = [
  {
    id: ServiceType.Insurance,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.Insurance],
  },
  {
    id: ServiceType.SimCard,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.SimCard],
  },
  {
    id: ServiceType.EssayReview,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.EssayReview],
  },
  {
    id: ServiceType.Guardianship,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.Guardianship],
  },
  {
    id: ServiceType.Accommodation,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.Accommodation],
  },
  {
    id: ServiceType.LawyerConsultation,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.LawyerConsultation],
  },
  {
    id: ServiceType.VisaSupport,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.VisaSupport],
  },
  {
    id: ServiceType.OnlineCourses,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.OnlineCourses],
  },
  {
    id: ServiceType.Library,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.Library],
  },
  {
    id: ServiceType.TravelAssistance,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.TravelAssistance],
  },
  {
    id: ServiceType.Internship,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.Internship],
  },
  {
    id: ServiceType.Volunteering,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.Volunteering],
  },
  {
    id: ServiceType.WorkAndTravel,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.WorkAndTravel],
  },
  {
    id: ServiceType.FindJob,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.FindJob],
  },
  {
    id: ServiceType.Ranking,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.Ranking],
  },
  {
    id: ServiceType.StudentLoan,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.StudentLoan],
  },
  {
    id: ServiceType.MoneyTransfer,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.MoneyTransfer],
  },
  {
    id: ServiceType.PickUpDropOff,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.PickUpDropOff],
  },
  {
    id: ServiceType.BankCard,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.BankCard],
  },
  {
    id: ServiceType.LanguageCourses,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.LanguageCourses],
  },
  {
    id: ServiceType.ShortProfessionalCourses,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.ShortProfessionalCourses],
  },
  {
    id: ServiceType.SummerSchools,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.SummerSchools],
  },
  {
    id: ServiceType.StudentToStudentCommunication,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.StudentToStudentCommunication],
  },
  {
    id: ServiceType.ImmigrationPrograms,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.ImmigrationPrograms],
  },
  {
    id: ServiceType.SupportService,
    name: SERVICE_TYPE_LABEL_MAP[ServiceType.SupportService],
  },
];

export const SERVICE_CATEGORY_LIST = SERVICE_TYPES_OPTIONS.map((type) => ({
  id: type.id,
  name: type.name,
  icon: SERVICE_TYPE_ICONS[type.id],
}));

export const DETAILS_MAP = {
  [ServiceDetailType.ServiceDetails]: "Service Details",
  [ServiceDetailType.OperatingCountries]: "Operating Countries / Locations",
  [ServiceDetailType.CostsAndPackages]: "Costs / Packages",
  [ServiceDetailType.PaymentPlanOptions]: "Payment Plan Options",
  [ServiceDetailType.CancellationPolicyAndRefunds]:
    "Cancellation Policy and Refunds",
  [ServiceDetailType.OtherComments]: "Other Comments",
  [ServiceDetailType.Upgrades]: "Upgrades",
  [ServiceDetailType.FAQ]: "FAQ",
};

export const detailsConfig: DetailConfig[] = [
  {
    type: ServiceDetailType.ServiceDetails,
    name: DETAILS_MAP[ServiceDetailType.ServiceDetails],
    isRequired: true,
  },
  {
    type: ServiceDetailType.OperatingCountries,
    name: DETAILS_MAP[ServiceDetailType.OperatingCountries],
    isRequired: true,
  },
  {
    type: ServiceDetailType.CostsAndPackages,
    name: DETAILS_MAP[ServiceDetailType.CostsAndPackages],
    isRequired: true,
  },
  {
    type: ServiceDetailType.CancellationPolicyAndRefunds,
    name: DETAILS_MAP[ServiceDetailType.CancellationPolicyAndRefunds],
    isRequired: true,
  },
  {
    type: ServiceDetailType.PaymentPlanOptions,
    name: DETAILS_MAP[ServiceDetailType.PaymentPlanOptions],
    isRequired: false,
  },
  {
    type: ServiceDetailType.OtherComments,
    name: DETAILS_MAP[ServiceDetailType.OtherComments],
    isRequired: false,
  },
  {
    type: ServiceDetailType.Upgrades,
    name: DETAILS_MAP[ServiceDetailType.Upgrades],
    isRequired: false,
  },
  {
    type: ServiceDetailType.FAQ,
    name: DETAILS_MAP[ServiceDetailType.FAQ],
    isRequired: false,
  },
];
